import { useTranslation } from "react-i18next";
import "../index.scss";

const FindingSummaryCards = ({ summary, loading }) => {
  const { t } = useTranslation();
  const cards = [
    { key: "critical", label: t("credentialScanning.severityCritical"), colorClass: "critical", value: summary?.critical ?? 0 },
    { key: "high", label: t("credentialScanning.severityHigh"), colorClass: "high", value: summary?.high ?? 0 },
    { key: "medium", label: t("credentialScanning.severityMedium"), colorClass: "medium", value: summary?.medium ?? 0 },
    { key: "low", label: t("credentialScanning.severityLow"), colorClass: "low", value: summary?.low ?? 0 },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        marginBottom: "24px",
      }}
    >
      {cards.map((card) => (
        <div
          key={card.key}
          className={`cred-scan-summary-card ${card.colorClass}`}
          style={{
            background: "var(--card-bg, #fff)",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          }}
        >
          <span className="count">
            {loading ? "—" : card.value.toLocaleString()}
          </span>
          <span className="label">{card.label}</span>
        </div>
      ))}
      <div
        className="cred-scan-summary-card"
        style={{
          borderLeft: "4px solid #5177ff",
          background: "var(--card-bg, #fff)",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        }}
      >
        <span className="count" style={{ color: "#5177ff" }}>
          {loading ? "—" : (summary?.total_open ?? 0).toLocaleString()}
        </span>
        <span className="label">{t("credentialScanning.totalOpen")}</span>
      </div>
    </div>
  );
};

export default FindingSummaryCards;
